import useHelpers from "../../../helpers";

const useAuthSelectors = () => {
  // Helpers
  const { useCreateSelector } = useHelpers();
  const { createSelector } = useCreateSelector();

  const session = createSelector(
    state => state.session,
    session => session
  );

  const mfaPending = createSelector(
    state => state.mfaPending,
    mfaPending => mfaPending
  );

  return {
    session,
    mfaPending,
  }
};

export default useAuthSelectors;